import type { ColorFamily } from '@/types'

// The palette shown in "Browse by color". Each wallpaper lands in one family based on its color field.
export const COLOR_FAMILIES: Array<ColorFamily> = [
    { slug: 'red', label: 'Red', swatch: '#E5484D' },
    { slug: 'orange', label: 'Orange', swatch: '#F2801F' },
    { slug: 'yellow', label: 'Yellow', swatch: '#E9C84A' },
    { slug: 'green', label: 'Green', swatch: '#3E9B6B' },
    { slug: 'teal', label: 'Teal', swatch: '#23B3A4' },
    { slug: 'blue', label: 'Blue', swatch: '#4A8FE8' },
    { slug: 'purple', label: 'Purple', swatch: '#8E6CE8' },
    { slug: 'pink', label: 'Pink', swatch: '#EE7BB8' },
    { slug: 'white', label: 'White', swatch: '#F2F0EC' },
    { slug: 'gray', label: 'Gray', swatch: '#8E8E93' },
    { slug: 'black', label: 'Black', swatch: '#151518' }
]
